import React from "react";

// GOLD Founding Member plate — the secondary seller mark that REPLACES "Pro" on buyer surfaces.
// Rendered directly below the seller panel, above the footer, ONLY for founding sellers. The call
// site suppresses it entirely for a revoked seller (a revoked account never gets the gold card).
// Treatment F4 (owner, 2026-06): dark gradient plate, 1px gold hairline, "FOUNDING MEMBER" label,
// the seat NUMBER carries the weight. NO star. No "OPTICSWAP" line (redundant inside our own product).
//   tokens: --gold #E8C46A (number) · --gold-mid #7A6428 (hairline) · --gold-label #C7A75A (label text)
const GOLD = "#E8C46A";
const GOLD_MID = "#7A6428";
const GOLD_LABEL = "#C7A75A";

export function FoundingPlate({ number, testid = "founding-plate" }) {
  const n = Number(number);
  if (!Number.isInteger(n) || n < 1) return null;
  return (
    <div
      data-testid={testid}
      className="mt-3 flex items-center justify-between"
      style={{
        border: `1px solid ${GOLD_MID}`,
        background: "linear-gradient(180deg, #2A2213, #1A150B)",
        padding: "11px 13px",
      }}
    >
      <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "10px", letterSpacing: "0.11em", color: GOLD_LABEL }}>
        FOUNDING MEMBER
      </div>
      <div
        className="font-heading tabular-nums"
        data-testid={`${testid}-seat`}
        style={{ fontWeight: 800, fontSize: "26px", color: GOLD, lineHeight: 1 }}
      >
        #{n}
      </div>
    </div>
  );
}

export default FoundingPlate;
